import { FAQ_LOADING, FAQ_SUCCESS, FAQ_FAILED } from '../Constants/faqConstants';

export const faqReducer = (
    state = { faqData: [] },
    action
) => {
    switch (action.type) {
        case FAQ_LOADING:
            return { loading: true, faqData: [] };
        case FAQ_SUCCESS:
            return { loading: false, faqData: action.payload };
        case FAQ_FAILED:
            return { loading: false, error: action.faqData };
        default:
            return state;
    }
};